<template>
  <div ref="pdfContent" class="pdf-content">
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import { mapGetters, mapActions, mapState } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import QRCode from "qrcode";

let APIDomain = new URL(window.location.href);
if (APIDomain.hostname != "localhost") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

export default {
  components: {
    Loader,
    QRCode,
  },
  data() {
    return {
      name: "PrintQuo",
      isLoadingData: false,
      projectID: "",
      partNo: 0,
      header: [],
      companyInfo: [],
      tableData: [],
      tableDataSales: [],
      customerInfo: {},
      lengthData: [],
      imageUrl: "",
      imageUrlBack: "",
      imageSrc: "", // Base64 data of the image
      employee_nik: null,
      employee_name: null,
      detailKeterangan: [],
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  created() {
    this.employee_nik = this.userData.nik;
    this.employee_name = this.userData.fullname;
    this.imgLogo();
    EventBus.$on("open-printquo", (data, index) => {
      this.projectID = data;
      console.log(data);
      this.partNo = index;
      this.loadData();
    });
  },
  beforeDestroy() {
    EventBus.$off("open-printquo");
  },
  methods: {
    loadData() {
      this.isLoadingData = true;
      localStorage.removeItem("redirect_url");
      fnPOST(APIPATH_SALESFORCE.getProjectDetail, {
        project_id: this.projectID,
      })
        .then((rsp) => {
          if (rsp.data.payload) {
            this.tableDataSales = rsp.data.payload;
            if (this.tableDataSales) {
              fnPOST(APIPATH_SALESFORCE.getQuotation, {
                project_id: this.projectID,
              })
                .then((rsp) => {
                  if (rsp.data.payload) {
                    let dataQuo = rsp.data.payload;
                    this.customerInfo = dataQuo[0];
                    fnPOST(APIPATH_SALESFORCE.getQuotationDet, {
                      project_id: this.projectID,
                    }).then((rsp) => {
                      let dataDet = rsp.data.payload;
                      this.detailKeterangan = dataDet;
                      this.generatePdf();
                    });
                  }
                })
                .catch((err) => {
                  this.isLoadingData = false;
                });
            }
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
        });
    },
    imgLogo() {
      let APIDomain = new URL(window.location.href);
      let APIPort = "8005";
      let protocol = "https://";
      let APIUrl = protocol + APIDomain.hostname + ":" + APIPort;
      if (APIDomain.hostname == "localhost") {
        APIUrl = "https://testapps.bbi-apparel.com:8005";
      }
      this.imageUrl = APIUrl + "/media/bbi-logo.png";
      this.imageUrlBack = APIUrl + "/media/background_quotation.jpg";
    },

    formatRupiah(val) {
      if (!val) return "";
      return "Rp" + Number(val).toLocaleString("id-ID");
    },

    getIndonesianDate(location = "Jakarta") {
      const today = new Date();
      const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      const day = today.getDate();
      const month = months[today.getMonth()];
      const year = today.getFullYear();

      return `${location}, ${day} ${month} ${year}`;
    },

    async convertImage(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Error converting image:", error);
        return null;
      }
    },

    async generatePdf() {
      const bgImage = await this.convertImage(this.imageUrlBack);
      let tableData = [
        ["No.", "Produk", "QTY", "Merk", "Bahan", "Harga Satuan", "Total"],
      ];

      this.tableDataSales.forEach((val, index) => {
        tableData.push([
          (index + 1).toString(), // No.
          val.item || "", // Produk
          val.qty || "", // QTY
          val.brand_name || "-", // Merk
          val.material_name || "-", // Bahan
          this.formatRupiah(val.est_cogs) || "", // Harga Satuan
          this.formatRupiah(val.est_cogs * val.qty) || "", // Total
        ]);
      });

      let grandTotal = this.tableDataSales.reduce((sum, val) => {
        let subtotal = (val.est_cogs || 0) * (val.qty || 0);
        return sum + subtotal;
      }, 0);

      const header = tableData[0];
      const body = tableData.slice(1);
      // Chunk logic
      let chunks = [];
      let pageIndex = 0;
      let i = 0;

      const customerText = [
        'Kepada YTH,',
        this.customerInfo.customer_name || '-',
        this.customerInfo.address || '-',
        this.customerInfo.attn || '-'
      ].join('\n');

      let dateNow = this.getIndonesianDate("Jakarta");

      while (i < body.length) {
        const chunkSize = pageIndex === 0 ? 10 : 20;
        chunks.push(body.slice(i, i + chunkSize));
        i += chunkSize;
        pageIndex++;
      }

      let content = [];
      this.isLoadingData = true;

      // Page 1: Add surat text first
      content.push(
        {
          text: dateNow,
          alignment: "right",
          margin: [0, 0, 0, 20],
        },
        {
          text: `Nomor: ${this.customerInfo.no_quotation}\nPerihal: Surat Penawaran Harga`,
          bold: true,
          margin: [0, 0, 0, 15],
        },
        {
          text: customerText,
          margin: [0, 0, 250, 15],
        },
        {
          text: "Dengan Hormat,",
          margin: [0, 0, 0, 10],
        },
        {
          text: `Kami, PT Binabusana Internusa, perusahaan yang bergerak dalam bidang industri pakaian jadi yang memproduksi dan memasarkan brand-brand nasional dan internasional ternama seperti: Valino, Arnold Palmer, dan Kent & Crew, dengan ini menyampaikan kepada ${this.customerInfo.customer_name} penawaran harga produk kami sebagai berikut:`,
          margin: [0, 0, 0, 20],
          alignment: "justify",
        }
      );

      // Add table chunks
      chunks.forEach((chunk, index) => {
        content.push({
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "auto", "auto", "auto", "auto"],
            body: [header, ...chunk],
          },
          layout: "lightHorizontalLines",
          margin: [0, 0, 0, 10],
          pageBreak: index > 0 ? "before" : undefined, // page break on 2nd+ pages
        });
      });

      // Grand Total after last chunk
      content.push({
        columns: [
          { text: "Grand Total", bold: true, alignment: "left" },
          {
            text: this.formatRupiah(grandTotal),
            bold: true,
            alignment: "right",
          },
        ],
        margin: [0, 0, 0, 15],
      });

      // Keterangan
      content.push({
        text: "Keterangan:",
        bold: true,
        margin: [0, 0, 0, 5],
      });
      content.push({
        ul: this.detailKeterangan.map((item) => ({
          text: item.value,
          alignment: "justify", // optional: applies to all
        })),
        margin: [10, 0, 0, 0],
      });
      // content.push({
      //   ul: [
      //     {
      //       text: "Masa berlaku penawaran harga s.d. 31 Januari 2026.",
      //       color: "#0000ff",
      //     },
      //     { text: "Harga belum termasuk PPN 11%.", color: "#0000ff" },
      //     {
      //       text: "Harga sudah termasuk ongkos kirim sampai lokasi tujuan (franco Jabodetabek).",
      //       color: "#0000ff",
      //     },
      //     {
      //       text: "Waktu pengerjaan 60 hari kalender setelah PO, data ukur, dan approval sample diterima lengkap.",
      //       color: "#0000ff",
      //       alignment: "justify",
      //     },
      //     {
      //       text: "Garansi kualitas pabrik 2 minggu sejak barang diterima.",
      //       color: "#0000ff",
      //     },
      //     {
      //       text: "TOP 30 hari kalender setelah barang dan invoice diterima.",
      //       color: "#0000ff",
      //     },
      //   ],
      //   margin: [10, 0, 0, 0],
      // });

      // Closing paragraph
      content.push({
        text: [
          "Demikian surat penawaran ini kami sampaikan. ",
          "Atas perhatian dan kerjasama ",
          { text: "Bapak atau Ibu", color: "#000000" },
          " kami mengucapkan terima kasih.",
        ],
        alignment: "justify",
        margin: [0, 20, 0, 20],
      });

      // Signature block
      content.push({
        alignment: "center", // center everything inside
        stack: [
          {
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: "Hormat kami,\nPT Binabusana Internusa",
                    margin: [0, 0, 0, 10],
                  },
                  { text: "__________________", margin: [0, 20, 0, 5] }, // empty signature
                  {
                    text: this.customerInfo.sales_group_name,
                    color: "#000000",
                    bold: true,
                  },
                  { text: "Sales Section Head" },
                ],
                alignment: "center", // center this column content
              },
              {
                width: "50%",
                stack: [
                  { text: "Mengetahui,", margin: [0, 0, 0, 10] },
                  { text: "__________________", margin: [0, 35, 0, 5] }, // empty signature
                  { text: "Sri Hartini", color: "#000000", bold: true },
                  { text: "Sub-Division Head" },
                ],
                alignment: "center", // center this column content
              },
            ],
            columnGap: 40,
          },
        ],
      });

      console.log("page");

      const docDefinition = {
        content: content,
        pageSize: "A4", // A4 page size
        pageOrientation: "potrait", // Landscape orientation
        pageMargins: [60, 80, 60, 80],
        background: function (currentPage, pageSize) {
          return {
            image: bgImage,
            width: pageSize.width,
            height: pageSize.height,
          };
        },
        styles: {
          header: {
            fontSize: 11,
            bold: true,
          },
        },
      };

      pdfMake.createPdf(docDefinition).open();
      this.isLoadingData = false;
    },
  },
};
</script>

<style scoped>
.pdf-content {
  display: block;
}
.header .title {
  display: flex;
  justify-content: space-between;
}
.company-info span,
.company-info p {
  margin: 0;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid black;
  padding: 5px;
}
th {
  background-color: #f2f2f2;
}
.total {
  text-align: right;
  font-weight: bold;
}
</style>
